import { Toast } from "vant";
export default {
  /**
   * 时间戳转换年月日
   */
  formattedDate(timestamp) {
    const date = new Date(timestamp * 1000);
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return date.toLocaleDateString("zh-CN", options);
  },
  /**
   * 手机号中间加*号
   */
  maskedString(originalString) {
    return originalString.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3");
  },
  /**
   * 提示
   */
  showToast( message, type = 'fail' ,duration = 1000,) {
    if (type === 'success') {
        Toast.success({
            duration: duration,
            message: message,
        });
    } else {
        Toast.fail({
            duration: duration,
            message: message,
        });
    }
  },
};



// WEBPACK FOOTER //
// ./src/utils/base.js